document.addEventListener("DOMContentLoaded", (function($) {
  var iframe = $(".pcc-modal.island-tour-modal iframe"),
      url=iframe.data("video-url")
  ;

  $(document).on("closeme.zf.reveal", loadIframe);
  $(document).on("closed.zf.reveal", resetIframe);

  function loadIframe() {
    iframe.attr("src", url);
    iframe.css("left", getImageCenter(iframe[0]));
  }

  function resetIframe() {
    iframe.attr("src", "");
  }

  function getImageCenter(element) {
    var elWidth = element.clientWidth,
        galleryWidth  = document.getElementsByClassName('pcc-modal__slider')[0].clientWidth
    ;
    return (galleryWidth/2) - (elWidth/2);
  }
})(jQuery));
